/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import { Constants } from '@ziynx/components/layout';
import { getDimensions } from '@ziynx/components/utilities';

export type Props = $ReadOnly<{|
  /**
   * Content passed in CardBase
   */
  children?: any,
  /**
   * Optional width for CardBase,
   * Default is 100% as handled by variant wide
   */
  width?: string | number,
  height?: string | number,
  padding?: boolean,
  boxShadow?: boolean,
|}>;

const CardComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ padding }) => padding && 'padding: 24px;'};
  border-radius: ${Constants.borderRadiusLarge}px;
  box-shadow: ${({ boxShadow }) => boxShadow && Constants.boxShadowTotal};
  width: ${({ width }) => getDimensions(width)};
  height: ${({ height }) => getDimensions(height)};
`;

/**
 * CardBase component
 */
const CardBase = (props: Props): React$Node => {
  const {
    padding, children, width, height, ...rest
  } = props;

  return (
    <CardComponent padding={padding} width={width} height={height} {...rest}>
      {children}
    </CardComponent>
  );
};

CardBase.defaultProps = {
  width: '100%',
  height: 'auto',
  padding: true,
  boxShadow: true,
};

export default CardBase;
